"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackToolbarImplementation_exports = {};
__export(StackToolbarImplementation_exports, {
  STACK_TOOLBAR_CHILD: () => STACK_TOOLBAR_CHILD,
  getStackToolbarImplementation: () => getStackToolbarImplementation,
  registerStackToolbarImplementation: () => registerStackToolbarImplementation
});
module.exports = __toCommonJS(StackToolbarImplementation_exports);
var STACK_TOOLBAR_CHILD = /* @__PURE__ */ Symbol.for("one.stack-toolbar.child");
var stackToolbarImplementation = null;
function registerStackToolbarImplementation(implementation) {
  stackToolbarImplementation = implementation;
}
function getStackToolbarImplementation() {
  return stackToolbarImplementation;
}
//# sourceMappingURL=StackToolbarImplementation.js.map
